import useFetchedDataWithPagination from 'hooks/useFetchedDataWithPagination'
import { displayPrice, toStringNumber } from 'utils/string'
import { toDateTime, toShortDate } from 'utils/date'
import { useEffect, useRef, useState } from 'react'
import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import useWarehouses from 'hooks/useWarehouses'
import { useParams } from 'react-router-dom'
import Input from 'components/inputs/Input'
import Filters from 'components/Filters'
import Loading from 'components/Loading'
import Error from 'components/Error'
import * as fields from './fields'
import * as urls from 'rest/urls'
import Item from '../Item'

const sortOptions = [{
  name: 'Domyślnie',
  value: ''
}, {
  name: 'Od najdroższej',
  value: 'grossAmount-desc'
}, {
  name: 'Od najtańszej',
  value: 'grossAmount-asc'
}, {
  name: 'Od najmłodszej',
  value: 'documentDate-desc'
}, {
  name: 'Od najstarszej',
  value: 'documentDate-asc'
},]

const InvoicesList = ({ amount, invoicesToPay, setInvoicesToPay, customWrapperClassName = '', showPayments }) => {

  const { id } = useParams()
  const [selectedSort, selectSort] = useState(sortOptions[0].value)
  const [filters, setFilters] = useState((() => {
    const _filters = {}
    if (id) _filters.warehousesIds = [id]
    if (window.location.search) {
      const query = new URLSearchParams(window.location.search)
      const isPaid = query.get('isPaid')
      if (isPaid) _filters.isPaid = isPaid
    }
    return _filters
  })())
 useWarehouses()

  const listRef = useRef(null)
  const { t, lang } = useTranslation()
  const { isLoading, data, handleScroll, reload } = useFetchedDataWithPagination(getListUrl(filters, selectedSort), listRef)

  const downloadFv = (link, updateItem = false) => {
    if (link) window.open(link, '_blank')
    if (updateItem) {
      reload()
    }
  }

  /**
   * eh...
   */
  useEffect(() => {
    const popup = document.querySelector(`.${customWrapperClassName || 'account__list'}`)
    if (popup) {
      listRef.current = popup
      popup.addEventListener('scroll', handleScroll)
      return () => {
        popup.removeEventListener('scroll', handleScroll)
      }
    }
  }, [customWrapperClassName, handleScroll])

  return (
    <>
      <Filters
        showFiltersBtn
        filters={filters}
        setFilters={setFilters}
        fields={fields[lang]}
        sortOptions={sortOptions}
        selectedSort={selectedSort}
        selectSort={selectSort}
      />

      <div className='account__list'>
        {data
          ? data?.length > 0
            ? data.map(({ id, documentDate, fullNumber, link, lastAccessDate, isPaid, grossAmount, remainingAmount }, i) => <Item
              key={i}
              label={toShortDate(documentDate, lang)}
              title={`FV ${fullNumber}`}
              icon={<div
                className={`circle center --${lastAccessDate ? 'checked' : 'unchecked'}`}
                onClick={() => {
                  downloadFv(link, !lastAccessDate)
                }} >
                <i className='icon icon--download' />
              </div>}
              desc={<>
                <div>
                  {isPaid
                    ? `Zapłacono: ${grossAmount}`
                    : `Do zapłaty: ${remainingAmount}${remainingAmount !== grossAmount ? ` z ${grossAmount}` : ''}`}
                </div>
                <div>{lastAccessDate ? `${t('account.downloaded')} ${toDateTime(lastAccessDate, lang)}` : t('account.notDownloaded')}</div>
              </>}
              right={invoicesToPay[id] !== undefined
                ? <div className='input__container'>
                  <Input
                    value={invoicesToPay[id]}
                    changeHandler={e => {
                      const { value } = e.target
                      if (value && !value.match(/^\d+\.?\d{0,2}$/)) return
                      setInvoicesToPay(prev => {
                        if (!value) {
                          return { ...prev, [id]: (value || '') }

                        } else {
                          const potentialNewValue = Number(value)
                          const maxInvoiceAmount = Number(remainingAmount)
                          const newValue = potentialNewValue > maxInvoiceAmount ? toStringNumber(maxInvoiceAmount) : value
                          return { ...prev, [id]: newValue }
                        }
                      })
                    }}
                  />
                  <i
                    className='icon icon--close'
                    onClick={() => {
                      setInvoicesToPay(prev => {
                        const { [id]: _, ...rest } = prev
                        return rest
                      })
                    }} />
                </div>
                : !isPaid
                  ? <div>
                    <ArrowBtn
                      text='Opłać'
                      showArrow={false}
                      action={() => {
                        setFilters(prev => ({ ...prev, isPaid: '0' }))
                        setInvoicesToPay(prev => ({ ...prev, [id]: remainingAmount }))
                      }}
                    />
                  </div>
                  : null}
            />)
            : <Error staticPos text={t('filters.noItems')} />
          : isLoading
            ? <Loading middleOfPage={!customWrapperClassName} />
            : <Error staticPos />}

        {amount > 0 && <ArrowBtn
          enlarged
          className='account__flyingButton'
          text={`Zapłać ${displayPrice(amount)}`}
          action={showPayments}
        />}
      </div>
    </>
  )
}

const getListUrl = (filters, selectedSort) => {
  const params = generateFilterParams(filters, selectedSort)
  return `${urls.invoices}${params ? `?${params}` : ''}`
}

const generateFilterParams = (filters, selectedSort) => {
  let filtersParam = ''
  for (const key in filters) {
    if (key !== 'warehousesIds') {
      if (filtersParam) filtersParam += ';'
      if (key === 'date') {
        filtersParam += `documentDate::${filters[key]?.start || ''},${filters[key]?.end || ''}`
      } else {
        filtersParam += `${key}::${filters[key]}`
      }
    }
  }

  const params = new URLSearchParams()
  if (filtersParam) params.append('filters', filtersParam)
  if (filters['warehousesIds'] && Array.isArray(filters['warehousesIds']) && filters['warehousesIds'].length > 0) {
    params.append('warehousesIds', filters['warehousesIds'].reduce((r, id) => r += (r ? ',' : '') + id, ''))
  }
  if (selectedSort) {
    const [orderBy, sortedBy] = selectedSort.split('-')
    if (orderBy && sortedBy) {
      params.append('orderBy', orderBy)
      params.append('sortedBy', sortedBy)
    }
  }
  return params.toString()
}

export default InvoicesList